import { useCallback, useEffect, useState } from "react"
import { EMBED_MESSAGE_SOURCE, EMBED_MESSAGES } from "./constants"

const postToHost = (type) => window.parent.postMessage({ source: EMBED_MESSAGE_SOURCE.widget, type }, "*")

// Handshake with the page the widget is embedded in (public/booking-widget.js). The X is only
// offered once the host answers that it can close the popup: a cached older copy of the script,
// the hosted /book page and a direct visit never answer, so they keep their own close (or none).
// Messages carry no data, so posting to any origin is safe.
const useEmbedHost = () => {
  const [isClosable, setIsClosable] = useState(false)

  useEffect(() => {
    if (window.parent === window) return undefined
    const handleMessage = (event) => {
      if (event.source !== window.parent) return
      if (event.data?.source === EMBED_MESSAGE_SOURCE.host && event.data.type === EMBED_MESSAGES.closeSupported) setIsClosable(true)
    }
    window.addEventListener("message", handleMessage)
    postToHost(EMBED_MESSAGES.ready)
    return () => window.removeEventListener("message", handleMessage)
  }, [])

  const requestClose = useCallback(() => postToHost(EMBED_MESSAGES.close), [])

  return { isClosable, requestClose }
}

export default useEmbedHost
